import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';
import moment from 'moment';

import StoreS3 from '../../util/StoreS3.jsx';
import InputTextBar from '../../util/InputTextBar.jsx';
import Common from '../../util/Common.jsx';

import WorksetItem from './WorksetItem.jsx';

const ContentWrapper = styled.div`
    margin: 0rem 1rem 1rem 0rem;
`;

const DataRow = styled.div`
    margin: 0;
`;

const SmallGenericButton = styled.div`
    display:inline-block;
    margin: 0.1rem 0.1rem;
    font-size: 0.8rem;
    vertical-align: top;
    cursor: pointer;
    font-style: italic;
    color: blue;
`;

const EditableName = styled.div`
    display: inline-block;
    font-weight: bold;
    color: blue;
    margin-right: 0.25rem;
    cursor: pointer;
    vertical-align: top;
`;

const TotalItems = styled.div`
    display: inline-block;
    font-family: courier;
    font-size: 0.95rem;
    font-weight: bold;
    margin-right: 0.5rem;
    cursor: pointer;
    color: black;
    vertical-align: middle;
`;

export class ListWorksetItems extends Component {

    static propTypes = {
        workset: PropTypes.object.isRequired
    }

    state = {
        workset_items: [],
        list_items: false,
        in_item_add: false
    };

    componentDidMount() {
        this.get_workset_items();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.workset !== this.props.workset) {
            this.setState({workset_items: []})
            this.get_workset_items();
        }
    }

    async get_workset_items() {
        const {workset} = this.props;
        const workset_folder = workset.path.substring(0, workset.path.length - 5);
        const workset_item_files = await StoreS3.list_files(workset_folder);
        const workset_items = [];
        for (let index = 0; index < workset_item_files.Contents.length; index++) {
            const workset_item_key = workset_item_files.Contents[index].Key.slice(9);
            const workset_item_file = await StoreS3.get_file(workset_item_key);
            const workset_item = JSON.parse(workset_item_file.Body);
            workset_items.push(workset_item)
        }
        const storage_name = workset.title + '_items';
        const list_items = localStorage.getItem(storage_name, 0)
        this.setState({
            workset_items: workset_items,
            list_items: list_items
        });
    }

    toggle_items_list() {
        const {list_items} = this.state;
        const {workset} = this.props;
        const storage_name = workset.title + '_items';
        if (!list_items) {
            localStorage.setItem(storage_name, 1)
        } else {
            localStorage.removeItem(storage_name)
        }
        this.setState({list_items: !list_items});
    }

    add_work_item() {
        this.setState({in_item_add: true});
    }

    confirm_add_item = (new_name) => {
        const slug_form = Common.slugify(new_name);
        if (!slug_form.length) {
            return;
        }
        const workset_folder = this.props.workset.path.substring(0, this.props.workset.path.length - 5);
        const path = workset_folder + "/" + slug_form + ".json";
        const data = {
            title: new_name,
            slug: slug_form,
            path: path,
            type: "workitem",
            value: "",
            index: this.state.workset_items.length + 1,
            created: moment().format(),
        }
        StoreS3.put_file(path, JSON.stringify(data, undefined, 2));
        const that = this;
        setTimeout(function () {
            that.get_workset_items();
            that.setState({
                in_item_add: false,
                list_items: true
            });
        }, 500);
    }

    cancel_add_item = () => {
        this.setState({in_item_add: false});
    }

    cancel_delete_item = () => {
        this.setState({in_item_delete: false});
    }

    items_row() {
        const add_item =
            <SmallGenericButton onClick={e => this.add_work_item()}>add...</SmallGenericButton>;
        const add_item_name = !this.state.in_item_add || this.state.in_item_delete ? '' :
            <InputTextBar
                callback_ok={this.confirm_add_item}
                callback_cancel={this.cancel_add_item}/>
        const item_list = !this.state.list_items ? '' :
            this.state.workset_items.sort((a, b) => a.index - b.index)
                .map(workset_item =>
                    <WorksetItem key={'key_' + workset_item.slug} workset_item={workset_item}/>)
        return <DataRow>
            <EditableName onClick={e => this.toggle_items_list()}>items:</EditableName>
            <TotalItems>total {this.state.workset_items.length}</TotalItems>
            {add_item}{add_item_name}
            {item_list}
        </DataRow>
    }

    render() {
        const items_row = this.items_row();
        return <ContentWrapper>
            {items_row}
        </ContentWrapper>
    }
}

export default ListWorksetItems;

